export default __webpack_public_path__ + "static/media/calendar_icon.88fc09c1.png";